import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/functions";
import "firebase/storage";
import "firebase/analytics";
import "firebase/remote-config";

const devConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  appId: process.env.VUE_APP_APPID,
  projectId: process.env.VUE_APP_PROJECTID,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_DATABASEURL,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGE,
  measurementId: process.env.VUE_APP_MEASUREMENTID,
};
enum AUTH_ERRORS {
  WRONG_PASS = "auth/wrong-password",
  NOT_FOUND = "auth/user-not-found",
  TOO_MANY_REQUESTS = "auth/too-many-requests",
  USER_DISABLED = "auth/user-disabled",
}

enum ROLE {
  SUPERADMIN,
  ADMIN,
  DEBUG,
  TESTER = 100,
  USER = 200,
  NONE = 1000,
}

firebase.initializeApp(devConfig);
const auth = firebase.auth();
const db = firebase.database();
const functions = firebase.functions();
const storage = firebase.storage();
const analytics = firebase.analytics();
const remoteConfig = firebase.remoteConfig();
remoteConfig.settings.minimumFetchIntervalMillis = 3600000;
remoteConfig.defaultConfig = {
  app_prelaunch_period_mins: 14400,
};

export {
  auth,
  db,
  firebase,
  functions,
  AUTH_ERRORS,
  ROLE,
  storage,
  remoteConfig,
  analytics,
};
